var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      [
        _vm.solucion.tags.includes("Discapacidad") &&
        (_vm.form.solicitud?.variablesSociodemograficas?.disDif?.valor?.nombre.includes(
          "Si"
        ) ||
          _vm.form.solicitud?.variablesSociodemograficas?.disDif?.valor?.nombre.includes(
            "No"
          ))
          ? _c(
              "b-container",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaUno"
                          ),
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disDif?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaDos"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disCam?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaTres"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disVer?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaCuatro"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disMov?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaCinco"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disApr?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaSeis"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disOir?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaSiete"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disHab?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaOcho"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disBan?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaNueve"
                          ),
                        },
                      },
                      [
                        _c("span", { attrs: { disabled: "" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.disRea?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.solucion.tags.includes("Indigenas") &&
        (_vm.form.solicitud?.variablesSociodemograficas?.perteCost?.valor?.nombre.includes(
          "Si"
        ) ||
          _vm.form.solicitud?.variablesSociodemograficas?.perteCost?.valor?.nombre.includes(
            "No"
          ))
          ? _c(
              "b-container",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaDiez"
                          ),
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.perteCost?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaOnce"
                          ),
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.pertePue?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaDoce"
                          ),
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.autodenominacion?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "label-size": "lg",
                          label: _vm.$t(
                            "apeironGwApp.variablesSociodemograficas.label.preguntaTrece"
                          ),
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.form.solicitud?.variablesSociodemograficas
                                ?.perteUste?.valor?.nombre
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("b-alert", { attrs: { show: "", variant: "info" } }, [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("apeironGwApp.variablesSociodemograficas.label.nota")
              ),
            },
          }),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }